<template>
  <div>
    <a-spin :spinning="isSubmiting">
      <a-form-item label="Loại biểu mẫu">
        <a-select
          show-search
          :loading="isGetFormsLoading"
          option-filter-prop="children"
          @change="setListFormField"
          style="width:100%"
          v-model="formData.form"
        >
          <a-select-option v-for="i in listForm" :key="i.id" :value="i.id">
            {{ i.formName }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <div v-if="formData.form">
        <hr />

        <a-form-item label="Mã">
          <a-input placeholder="Vui lòng nhập mã" v-model="formData.code" />
        </a-form-item>
        <a-form-item label="Tiêu đề">
          <a-input
            placeholder="Vui lòng nhập tiêu đề"
            v-model="formData.title"
          />
        </a-form-item>
        <a-form-item label="Mô tả">
          <a-textarea
            placeholder="Nhập mô tả"
            :autoSize="{ minRows: 2, maxRows: 6 }"
            v-model="formData.description"
          />
        </a-form-item>
      </div>

      <template v-if="listFormField && listFormField.length > 0">
        <hr />
        <ToInput
          v-for="field in listFormField"
          :key="field.id"
          :field="field"
          v-model="formChild[field.code]"
        />
      </template>

      <!-- Nút chèn word template -->

      <!--      <InsertWordTemplateBtn v-if="formData.form" />-->
      <br />
      <br />
      <!-- Hiển thị nút Lưu khi đã chọn loại FORM -->
      <template v-if="formData.form">
        <a-button type="primary" @click="handleSubmit" :loading="isSubmiting">
          <a-icon type="save" /> Lưu văn bản
        </a-button>
        <!-- <a-button type="primary" ghost icon="plus" size="small">
        Lưu văn bản
      </a-button>
      <a-button type="primary" icon="plus" size="small">
        Lưu & Trình duyệt
      </a-button> -->
      </template></a-spin
    >
  </div>
</template>

<script>
import { mapMutations } from "vuex";

import uploadFile from "@/services/uploadFile";
import getDocumentAsCompressedNew from "@/services/getCurrentFileWord";
import { createContentControl } from "@/services/contentControl";

import InsertWordTemplateBtn from "@/components/WordTemplates/InsertWordTemplateBtn.vue";
import ToInput from "@/components/DataToInput/ConvertDataToInput.vue";

import mutationQuery from "./Contants/mutation";
import query from "./Contants/query";
import gql from "graphql-tag";

export default {
  components: { ToInput, InsertWordTemplateBtn },
  data() {
    return {
      form: this.$form.createForm(this),
      isGetFormsLoading: false,
      isSubmiting: false,
      listForm: [],
      listFormField: [],
      formData: {
        title: "",
        code: "",
        description: "",
        fileUrl: undefined
      },
      formChild: {}
    };
  },
  // computed: {
  //   msToken() {
  //     return this.$store.state.auth.msToken;
  //   },
  // },
  methods: {
    ...mapMutations({
      setForm: "form/setForm"
    }),
    async getMsToken() {
      let token;
      try {
        const result = await this.$apollo.query({
          query: gql`
            query {
              refreshMsToken
            }
          `
        });
        token = result?.data?.refreshMsToken;
      } catch (e) {
        console.error(e);
      }
      return token;
    },
    // Hàm lưu thông tin
    async handleSubmit() {
      this.isSubmiting = true;

      // get MS Token
      const msToken = await this.getMsToken();

      const tranformData = {
        ...this.formData,

        // Biến đổi dữ liệu thật phức tạp
        createdFormFields: JSON.stringify(
          this.listFormField.map(f => {
            return {
              ...f,
              value: this.formChild[f.code]
            };
          })
        )
      };

      this.$apollo
        .mutate({
          // Query
          mutation: mutationQuery.createCreatedForm,
          // Parameters
          variables: tranformData
        })
        .then(async data => {
          if (!data.data || !data.data.createCreatedForm) {
            console.log("Lỗi khi tạo form!", data);
            return;
          }
          // Result
          const { id, code, title } = data.data.createCreatedForm;

          // Watermark ID lên file
          await createContentControl(id);

          // NOTE:
          /**
           *  1) Cần lưu quyền xem cho từng user trên file hoặc folder trên SP
           * do hiện tại có thể xem chung luôn
           *  2) Không cần lưu fileUrl do hệ thống đã đóng watermark lên file
           *  để nhận dạng là ID của phiếu
           */

          // Bắt đầu lưu file lên SP
          const filename = "Tệp trình duyệt - " + title + ".docx";
          const fileReved = await getDocumentAsCompressedNew(filename);
          const fileUploaded = await uploadFile(msToken, id, code, fileReved);
          console.log("File uploaded", fileUploaded);

          this.setForm(data.data.createCreatedForm);
          this.isSubmiting = false;
        })
        .catch(error => {
          // Error
          console.error("Up lỗi rồi", error);
          this.isSubmiting = false;
        });
    },
    // Tạo field động sau khi chọn Form
    setListFormField(item) {
      if (this.listForm && this.listForm.find && this.listForm.length > 0) {
        const selectedItem = this.listForm.find(e => e.id === item);
        const { formFields } = selectedItem;

        if (formFields && formFields.length > 0) {
          this.listFormField = formFields;
        }
      }
    }
  },
  created() {
    // Lấy danh sách form
    this.isGetFormsLoading = true;
    this.$apollo
      .query({
        query: query.forms
      })
      .then(data => {
        this.isGetFormsLoading = false;
        if (!data.error || !data.errors) {
          this.listForm = data.data.forms;
        }
      })
      .catch(error => {
        console.log("Loi", error);
        this.isGetFormsLoading = false;
      });
  }
};
</script>
